const val veryLargeMessageThreshold = 20 * 1024
val veryLargeDataFieldThreshold = 5 * 1024